import React from 'react';
import { ReactComponent as LogoTracciato } from '../../assets/logo-tracciato.svg';

// Il logo MK che si disegna: i contorni del logo vero (assets/logo-tracciato.svg, generato da
// scripts/traccia_logo.py), prima il tratto d'oro e poi il riempimento. Tempi e colori in accesso.css.
// Stessa inquadratura della bozza; l'alone che pulsa sulla finestra sta in un secondo SVG sopra.
const INQUADRATURA = '140 200 760 580';

const LogoAnimato = () => (
  <>
    <LogoTracciato viewBox={INQUADRATURA} role="img" aria-label="MK Consulting" />
    <svg className="alone" viewBox={INQUADRATURA} aria-hidden="true">
      <circle className="halo" cx="512" cy="356" r="10" />
    </svg>
  </>
);

export default LogoAnimato;
